import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/content";

export default function EditorialMarquee() {
  return (
    <section
      className="relative border-y border-white/10 bg-black py-8 sm:py-10"
      data-testid="marquee"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {MARQUEE_ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-display text-4xl sm:text-6xl font-bold uppercase tracking-tight text-stroke">
              {item}
            </span>
            <span className="text-2xl text-zinc-600">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
